import React, {useMemo} from 'react';
import {ALIGN, DISPLAY, FLEX_DIRECTION, useDevice, View} from '@lookiero/aurora';

import {Skeleton as NavButtonSkeleton} from '../NavButton';
import {style as navOptionsStyle} from './NavOptions.style';

export const Skeleton: React.FC = () => {
  const {screen} = useDevice();

  const style = useMemo(() => navOptionsStyle(), []);

  return (
    <View
      display={DISPLAY.FLEX}
      flexDirection={FLEX_DIRECTION.ROW}
      justifyContent={ALIGN.AROUND}
      alignItems={ALIGN.CENTER}
      wide={!screen.L}
      style={screen.L ? style.panelLarge : style.panel}
    >
      <NavButtonSkeleton />
      <NavButtonSkeleton />
      <NavButtonSkeleton />
      <NavButtonSkeleton />
    </View>
  );
};
